<template>
  <div>
    <div class="max-w">
      <div class="flex">
        <div class="left">
          <div class="txt" v-html="contact.detail"></div>
          <div class="contact">
            <div class="info" v-show="info.fax">
              <img src="@/assets/images/footer/fax.svg" alt="fax" />传真：{{
                info.fax
              }}
            </div>
            <div class="info" v-show="info.phone">
              <img src="@/assets/images/footer/phone.svg" alt="phone" />座机：{{
                info.phone
              }}
            </div>
            <div class="info" v-show="info.email">
              <img src="@/assets/images/footer/email.svg" alt="email" />邮箱：{{
                info.email
              }}
            </div>
            <div class="info" v-show="info.telephone">
              <img
                src="@/assets/images/footer/telephone.svg"
                alt="telephone"
              />手机号：{{ info.telephone }}
            </div>
            <div class="info" v-show="info.address">
              <img
                src="@/assets/images/footer/address.svg"
                alt="address"
              />地址：{{ info.address }}
            </div>
          </div>
        </div>

        <el-amap
          vid="amapDemo"
          :zoom="map.zoom"
          :center="map.center"
          :scrollWheel="false"
        >
          <el-amap-marker
            :position="map.marker"
            :icon="map.icon"
          ></el-amap-marker>
        </el-amap>
      </div>
    </div>
  </div>
</template>

<script>
import { getPage, getFooter } from "@/api/web";
export default {
  data() {
    return {
      contact: {},
      info: {
        address: "",
        gaicp: "",
        icp: "",
        phone: "",
        email: "",
        fax: "",
        people: "",
        telephone: "",
      },
      map: {
        zoom: 14,
        center: [120.87687,28.015281],
        marker: [120.87687,28.015281],
        icon: require("@/assets/images/map.png"),
      },
    };
  },
  created() {
    this.getInfo();
    getFooter().then((res) => {
      this.info = res.data;
    });
  },
  methods: {
    getInfo() {
      getPage(this.$route.meta.id).then((res) => {
        this.contact = res.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex {
  align-items: flex-start;
}
.el-vue-amap-container {
  width: 50%;
  height: 50vh;
  margin: 24px 0;
}
.left {
  margin: 24px 0;
  .txt {
    line-height: 1.5;
     margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e5e5;
  }
}
.contact {
 
  .info {
    line-height: 2;
    img {
      margin-right: 10px;
      position: relative;
      top: 5px;
      background: #3d8aff;
      border-radius: 50%;
    }
  }
}
@media only screen and (max-width: 1200px) {
  .flex {
    display: block;
  }
  .el-vue-amap-container {
    width: 100%;
  }
}
</style>
